import React from 'react'
function BannerInfo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      <h2 className="card-title">OBJETOS BÁSICOS Y FUNDAMENTALES</h2>
      <p className="card-text">
      IDERA considera como fundamental a aquellos datos geoespaciales relevantes para el desarrollo
de la región, producidos por organizaciones o instituciones involucradas en la toma de
decisiones y que deben estar disponibles y ser confiables para la generación de nuevos datos.<br/><br/>
(documento de IDERA)
https://campus.idera.gob.ar/pluginfile.php/2454/mod_resource/content/2/DescripcinDByF_V2.0_IDERA.pdf
      </p>
    </div>
  </div>
</div>

  )
}

export default BannerInfo